import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gate" }
const _hoisted_2 = { class: "gate__header form-custom" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "bt-icon bt-icon--m" }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "list-bubbles list-bubbles--xs ml-auto mr-3" }
const _hoisted_7 = { class: "bt-icon bt-icon--xs" }
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = { class: "confirmation-content" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_DialogAddEditGate = _resolveComponent("DialogAddEditGate")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("li", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_InlineSvgScoped, {
              src: 
                            require(`@/assets/images/entrancePlants/icon-gate.svg`)
                        ,
              "aria-label": "icon-gate"
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "plantname",
              modelValue: _ctx.gate.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.gate.name = $event)),
              class: ["w-100 ml-3 text-uppercase", { 'rename-gate-enabled': _ctx.plantInlineRenameEnabled }],
              disabled: !_ctx.plantInlineRenameEnabled
            }, null, 8, ["modelValue", "disabled", "class"])
          ])
        ]),
        _createVNode("div", {
          class: "spacer",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToGateDetail && _ctx.goToGateDetail(...args)))
        }, "_"),
        _createVNode("div", _hoisted_6, [
          (_openBlock(), _createBlock("div", {
            key: _ctx.gateDeviceCount,
            class: "p-button p-button-rounded p-button-secondary fs-14 no-click"
          }, _toDisplayString(_ctx.gateDeviceCount), 1))
        ]),
        (_ctx.showActionButton)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "apartment__action p-button-rounded p-button-outlined",
              disabled: _ctx.disabled,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleEditGateDialog(_ctx.gate)))
            }, {
              default: _withCtx(() => [
                _createVNode("span", _hoisted_7, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                            require(`@/assets/images/icons/icon-plus-outline.svg`)
                        ,
                    "aria-label": "icon-grid"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("entrancePlant.addDevice")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          icon: "pi pi-chevron-right",
          class: "p-button-text p-button-secondary ml-3",
          onClick: _ctx.goToGateDetail
        }, null, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      modal: true,
      visible: !_ctx.isValidName,
      style: { width: '350px' },
      closable: false,
      header: _ctx.$t('uniqueNaming.unavailableName')
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-primary p-button-rounded p-button--m",
          onClick: _ctx.onHideNameValidationDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Ok")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_9, [
          _createVNode("p", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.invalidNameReason) + " ", 1),
            _hoisted_11,
            _createVNode("sub", null, _toDisplayString(_ctx.$t("uniqueNaming.nameResetDisclaimer")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    _createVNode(_component_DialogAddEditGate, {
      gateToEdit: _ctx.gateToEdit,
      isVisible: _ctx.isEditGateDialogVisible,
      onlyDevices: "",
      onHideDialog: _ctx.toggleEditGateDialog,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["gateToEdit", "isVisible", "onHideDialog", "onUpdateList"])
  ], 64))
}